export enum EQueryParameterKeys {
  ActiveTable = "activeTable",
  DaysOnLot = "DaysOnLot",
  EndDate = "endDate",
  ResultScore = "resultScore",
  StartDate = "startDate",
  TipReportTableSource = "tipReportTableSource",
  DOL = "dol",
  DolRange = "dolRange",
  LeadsZero = "leadsZero",
  Source = "source",
  dolFrom = "dol_from",
  dolTo = "dol_to",
  Search = "search",
  dol_max = "dol_max",
  dol_min = "dol_min",
  LINK_FROM = "link_from",
  is_less_than_5_asc_leads = "is_less_than_5_asc_leads",
}

export enum ERoutesAnchors {
  MerchandisingTables = "merchandising-tables",
  ReportingTables = "reporting-tables",
}

enum ERoutes {
  Home = "/",
  ForgotPassword = "/forgot-password",
  Login = "/login",
  MarketingResults = "/marketing-results",
  Merchandising = "/merchandising",
  Reporting = "/reporting",
  SignUp = "/signup",
  ChangePassword = "/change-password",
  VDPResults = "/vdp-results",
  VDPResultsV2 = "/vdp-results-v2",
  LeadDetails = "/lead-details",
  VDPBoost = "/vdp-boost",
  ResultScoreDetails = "/result-score-details",
  MoneyList = "/money-list",
  ImportFile = "/import-file",
}

export default ERoutes;
